class RestaurantLeadForm {
    constructor(modal) {
        this.modal = modal;
        this.form = modal.querySelector('[data-restaurant-lead-form]');
        this.copy = JSON.parse(modal.querySelector('[data-restaurant-lead-copy]').textContent);
        this.dialog = bootstrap.Modal.getOrCreateInstance(modal);
        this.step = 1;
        this.bindEvents();
    }

    bindEvents() {
        this.modal.addEventListener('show.bs.modal', () => document.body.classList.add('restaurant-lead-is-open'));
        this.modal.addEventListener('hidden.bs.modal', () => document.body.classList.remove('restaurant-lead-is-open'));

        document.querySelectorAll('.triggerFormTestForFree, .triggerFormOrderPresentation').forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                this.open(trigger.classList.contains('triggerFormOrderPresentation') ? 'order_presentation' : 'test_for_free');
            });
        });

        this.form.addEventListener('change', (event) => {
            if (event.target.name === 'reason') this.form.querySelector('[data-lead-next]').disabled = false;
        });
        this.form.querySelector('[data-lead-next]').addEventListener('click', () => this.next());
        this.form.querySelector('[data-lead-back]').addEventListener('click', () => this.showStep(this.step - 1));
    }

    open(intent) {
        this.form.reset();
        this.form.classList.remove('was-validated');
        this.form.intent.value = intent;
        this.hideError();
        this.showStep(1);
        this.dialog.show();
        this.track('restaurant_lead_open', { intent });
    }

    showStep(step) {
        this.step = step;
        this.form.querySelectorAll('[data-lead-step]').forEach((element) => {
            element.classList.toggle('d-none', Number(element.dataset.leadStep) !== step);
        });

        const footer = this.form.querySelector('[data-lead-footer]');
        const back = this.form.querySelector('[data-lead-back]');
        const next = this.form.querySelector('[data-lead-next]');
        const label = this.form.querySelector('[data-lead-next-label]');
        const progress = this.form.querySelector('[data-lead-progress]');

        footer.classList.toggle('d-none', step === 4);
        back.classList.toggle('invisible', step === 1);
        next.disabled = step === 1 && !this.selectedReason();
        label.textContent = step === 3 ? this.copy.intents[this.form.intent.value].action : this.copy.next;
        progress.style.width = `${Math.min(step, 3) * 33.333}%`;
        progress.parentElement.setAttribute('aria-valuenow', String(Math.min(step, 3)));
        this.modal.querySelector('[data-lead-encourage]').textContent = this.copy.encouragement[step];

        if (step === 2) this.fillSolution();
        if (step === 3) this.fillContact();
    }

    selectedReason() {
        return this.form.querySelector('input[name="reason"]:checked')?.value;
    }

    fillSolution() {
        const reason = this.copy.reasons[this.selectedReason()];
        this.form.querySelector('[data-lead-empathy]').textContent = reason.empathy;
        this.form.querySelector('[data-lead-solution]').textContent = reason.solution;
        this.form.querySelector('[data-lead-value]').textContent = reason.value;
        this.renderPerks();
    }

    fillContact() {
        const intent = this.copy.intents[this.form.intent.value];
        this.form.querySelector('[data-lead-contact-eyebrow]').textContent = intent.eyebrow;
        this.form.querySelector('[data-lead-contact-lead]').textContent = this.copy.contact_lead.replace(':goal', this.copy.reasons[this.selectedReason()].goal);
        this.renderPerks();
    }

    renderPerks() {
        const badges = this.copy.intents[this.form.intent.value].perks.map((perk) => {
            const badge = document.createElement('span');
            badge.className = 'badge rounded-pill text-bg-light border text-dark py-2 px-3';
            badge.textContent = `✓ ${perk}`;
            return badge;
        });

        this.form.querySelector('[data-lead-perks]').replaceChildren(...badges);
    }

    next() {
        if (this.step < 3) {
            this.track('restaurant_lead_step', { step: this.step, reason: this.selectedReason() });
            this.showStep(this.step + 1);
            return;
        }

        if (!this.form.checkValidity()) {
            this.form.classList.add('was-validated');
            this.form.querySelector(':invalid')?.focus();
            return;
        }

        this.submit();
    }

    async submit() {
        const button = this.form.querySelector('[data-lead-next]');
        const label = this.form.querySelector('[data-lead-next-label]');
        const query = new URLSearchParams(window.location.search);
        const originalLabel = label.textContent;

        button.disabled = true;
        label.textContent = this.copy.sending;
        this.hideError();

        try {
            await axios.post(this.form.dataset.endpoint, {
                intent: this.form.intent.value,
                reason: this.selectedReason(),
                name: this.form.name.value.trim(),
                restaurant_name: this.form.restaurant_name.value.trim(),
                city: this.form.city.value.trim(),
                email: this.form.email.value.trim(),
                phone: this.form.phone.value.trim(),
                website: this.form.website.value.trim() || null,
                consent: this.form.consent.checked,
                source_url: window.location.href,
                utm_source: query.get('utm_source'),
                utm_medium: query.get('utm_medium'),
                utm_campaign: query.get('utm_campaign'),
                fbclid: query.get('fbclid'),
                gclid: query.get('gclid'),
            });

            const intent = this.copy.intents[this.form.intent.value];
            this.form.querySelector('[data-lead-success-title]').textContent = intent.success_title;
            this.form.querySelector('[data-lead-success-copy]').textContent = intent.success_copy;
            this.track('restaurant_lead_complete', { intent: this.form.intent.value, reason: this.selectedReason() });
            this.showStep(4);
        } catch (error) {
            this.showError(error);
            button.disabled = false;
            label.textContent = originalLabel;
        }
    }

    showError(error) {
        const box = this.form.querySelector('[data-lead-error]');
        const messages = Object.values(error.response?.data?.errors || {}).flat();
        const title = document.createElement('div');
        title.textContent = messages.length ? this.copy.validation_error : this.copy.send_error;
        box.replaceChildren(title);

        if (messages.length) {
            const list = document.createElement('ul');
            list.className = 'mb-0 mt-2 ps-3';
            [...new Set(messages)].forEach((message) => {
                const item = document.createElement('li');
                item.textContent = message;
                list.append(item);
            });
            box.append(list);
        }

        box.classList.remove('d-none');
    }

    hideError() {
        this.form.querySelector('[data-lead-error]').classList.add('d-none');
    }

    track(event, data = {}) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...data });
    }
}

const restaurantLeadModal = document.getElementById('restaurantLeadModal');

if (restaurantLeadModal) {
    const restaurantLeadForm = new RestaurantLeadForm(restaurantLeadModal);
    const initialIntent = new URLSearchParams(window.location.search).get('lead');

    if (restaurantLeadForm.copy.intents[initialIntent]) restaurantLeadForm.open(initialIntent);
}
